import { Injectable } from '@angular/core';
import { QueryStringService } from './query-string.service';

@Injectable({
  providedIn: 'root'
})

export class ScriptInjectorService {

  constructor(private queryStringHandler: QueryStringService) { }


  private getScriptToInject(src: string): HTMLScriptElement {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    script.async = true;
    return script;
  }

  injectABtastyScript() {
    const urlParams = new URLSearchParams(window.location.search);
    const qsp = urlParams.get('disableabtasty');
    if (qsp != 'true') {
      const script = this.getScriptToInject('https://try.abtasty.com/709389f5f152d448ed658c06bdf96458.js');
      document.head.insertBefore(script, document.head.firstChild);
    }
  }
}
